import "core-js/modules/es6.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FibSelect',
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number, Array, Object],
      default: null
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disable: {
      type: Boolean,
      default: false
    },
    optionLabel: {
      type: String,
      default: 'label'
    },
    optionValue: {
      type: String,
      default: 'value'
    },
    defaultSelect: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleChange: function handleChange(value) {
      this.$emit('input', value);
    }
  }
};